<div
  class="bg-white rounded-2xl w-full py-4 px-6 dark:bg-second-dark"
  [ngClass]="{ 'border border-[#EAEAEA]': label === 'modify' }"
>
  <!-- only phone -->
  @if(label === 'modify'){

  <div class="lg:hidden flex justify-between items-center mb-3">
    <h3 class="font-medium text-lg text-black dark:text-[#F1F1F1]">
      {{ "Search.Button_Search" | translate }}
    </h3>
    <button
      (click)="closeSearchModal()"
      class="text-white dark:text-primary-dark bg-[#6B7280] dark:bg-[#A5A6A8] text-lg w-6 h-6 rounded-full flex items-center justify-center font-bold leading-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
  }
  <!-- tabs -->
  <div
    class="flex justify-center md:justify-start text-[12px] sm:text-sm items-center gap-4 py-2"
  >
    @for(searchTab of searchTabs; track i ; let i = $index ){
    <button
      (click)="onTabChange(searchTab.value)"
      [ngClass]="{
        'bg-secondary border-secondary text-white transition-all duration-300 ease-out opacity-100 translate-y-0 dark:bg-primary-dark dark:border-second-dark':
          selectedTab === searchTab.value
      }"
      class="rounded-2xl text-secondary font-medium md:px-4 w-full md:w-fit py-2 border-1 common-border dark:border-border-dark dark:text-white"
    >
      {{ searchTab.key | translate }}
    </button>
    }
  </div>

  <form [formGroup]="searchForm">
    <ng-container formArrayName="trips">
      @for (trip of trips.controls; track trip; let i = $index) {

      <div [formGroupName]="i">
        <div class="flex gap-4 justify-between flex-col lg:flex-row py-2">
          <div
            class="relative flex flex-col md:flex-row items-center gap-4 lg:w-[50%] w-full"
          >
            <!-- From: the field opens the airport picker over itself (the results-page search's) -->
            <div
              [ngClass]="{
                'is-invalid':
                  isSubmitted && getTripControl(i, 'departureAirport').invalid,
                'shadow-[inset_0_0_0_1.5px_#369be7]': isAirportOpen(i, 'from')
              }"
              (appClickOutside)="isAirportOpen(i, 'from') && closeAirports()"
              class="input-search w-full lg:w-[48%] xl:w-full relative"
            >
              <button
                type="button"
                class="block w-full text-start cursor-pointer"
                [attr.aria-expanded]="isAirportOpen(i, 'from')"
                (click)="toggleAirport('from', i)"
              >
                <span class="label-search">{{
                  "Search.From" | translate
                }}</span>
                <span class="flex items-center gap-2">
                  <img src="/icons/from.svg" alt="" class="w-6 h-6" />
                  <span
                    class="truncate"
                    [ngClass]="
                      airportOf(i, 'from')?.iata
                        ? 'text-secondary dark:text-white font-medium'
                        : 'text-muted font-normal'
                    "
                    >{{ apText(i, "from") }}</span
                  >
                </span>
              </button>

              @if (isAirportOpen(i, 'from')) {
              <app-home-airport-picker
                [cityType]="'from'"
                [index]="i"
                [current]="airportOf(i, 'from')"
                (picked)="onAirportPicked($event)"
                (cancel)="closeAirports()"
              />
              }
            </div>

            <!-- To: the field opens the airport picker over itself (the results-page search's) -->
            <div
              [ngClass]="{
                'is-invalid':
                  isSubmitted && getTripControl(i, 'arrivalAirport').invalid,
                'shadow-[inset_0_0_0_1.5px_#369be7]': isAirportOpen(i, 'to')
              }"
              (appClickOutside)="isAirportOpen(i, 'to') && closeAirports()"
              class="input-search w-full lg:w-[48%] xl:w-full relative"
            >
              <button
                type="button"
                class="block w-full text-start cursor-pointer"
                [attr.aria-expanded]="isAirportOpen(i, 'to')"
                (click)="toggleAirport('to', i)"
              >
                <span class="label-search">{{ "Search.To" | translate }}</span>
                <span class="flex items-center gap-2">
                  <img src="/icons/to.svg" alt="" class="w-6 h-6" />
                  <span
                    class="truncate"
                    [ngClass]="
                      airportOf(i, 'to')?.iata
                        ? 'text-secondary dark:text-white font-medium'
                        : 'text-muted font-normal'
                    "
                    >{{ apText(i, "to") }}</span
                  >
                </span>
              </button>

              @if (isAirportOpen(i, 'to')) {
              <app-home-airport-picker
                [cityType]="'to'"
                [index]="i"
                [current]="airportOf(i, 'to')"
                (picked)="onAirportPicked($event)"
                (cancel)="closeAirports()"
              />
              }
            </div>

            <!--  Swap -->
            <button
              [ngClass]="{
                'is-invalid':
                  isSubmitted &&
                  (searchForm.get('departureAirport')?.invalid ||
                    searchForm.get('arrivalAirport')?.invalid)
              }"
              (click)="swapCities(i)"
              aria-label="Swap From and To"
              title="Swap"
              type="button"
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-brand rounded-lg shadow-md w-9 h-9 flex items-center justify-center transition"
            >
              <img src="/icons/arrow-2.svg" alt="arrow-icon" />
            </button>
          </div>
          <!-- dates: the results-page search's calendar (two months, Cancel / Apply) -->
          <div
            class="flex md:flex-row md:justify-between flex-col items-center gap-4 w-full lg:w-[50%] text-[12px] sm:text-base"
          >
            <ng-container
              [ngTemplateOutlet]="dateBoxTpl"
              [ngTemplateOutletContext]="{ i, field: 'departDate', half: selectedTab === 'Round Trip' }"
            />
            <!-- Multi City: every flight has its ×, off while there are only 2 -->
            @if (isMulti) {
            <button
              type="button"
              class="flex-none self-center grid place-items-center w-6 h-6 rounded-full text-[#161a25] dark:text-[#f1f1f1] disabled:opacity-25 disabled:cursor-default"
              [disabled]="trips.length <= minFlights"
              [attr.aria-label]="
                'Search.Remove_Flight' | translate : { n: i + 1 }
              "
              (click)="removeFlight(i)"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 32 32"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M16 2.667C8.653 2.667 2.667 8.653 2.667 16C2.667 23.347 8.653 29.333 16 29.333C23.347 29.333 29.333 23.347 29.333 16C29.333 8.653 23.347 2.667 16 2.667ZM20.48 19.067C20.867 19.453 20.867 20.093 20.48 20.48C20.28 20.68 20.027 20.773 19.773 20.773C19.52 20.773 19.267 20.68 19.067 20.48L16 17.413L12.933 20.48C12.733 20.68 12.48 20.773 12.227 20.773C11.973 20.773 11.72 20.68 11.52 20.48C11.133 20.093 11.133 19.453 11.52 19.067L14.587 16L11.52 12.933C11.133 12.547 11.133 11.907 11.52 11.52C11.907 11.133 12.547 11.133 12.933 11.52L16 14.587L19.067 11.52C19.453 11.133 20.093 11.133 20.48 11.52C20.867 11.907 20.867 12.547 20.48 12.933L17.413 16L20.48 19.067Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            } @if (selectedTab === 'Round Trip') {
            <ng-container
              [ngTemplateOutlet]="dateBoxTpl"
              [ngTemplateOutletContext]="{ i, field: 'returnDate', half: true }"
            />
            }
          </div>
        </div>
      </div>
      }
    </ng-container>
    <!-- Multi City: a new flight from the previous destination, 3 days later (5 at most) -->
    @if (isMulti) {
    <div class="py-2">
      <button
        type="button"
        class="inline-flex items-center justify-center gap-1.5 w-full h-11 px-4 rounded-[10px] border border-dashed border-[#cdd6e1] dark:border-[#2c2c6a] text-[#369be7] enabled:hover:border-[#369be7] enabled:hover:bg-[#f1f9ff] dark:enabled:hover:bg-[#22225e] disabled:opacity-40 disabled:cursor-default"
        [disabled]="trips.length >= maxFlights"
        (click)="addFlight()"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
            fill="currentColor"
          />
          <path
            d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
            fill="currentColor"
          />
        </svg>
        <span>{{ "Search.Add_More_Flight" | translate }}</span>
      </button>
    </div>
    }
    <!-- passenger , class , stops , and search -->

    <div
      class="w-full grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 mt-0 md:mt-4"
    >
      <!-- passengers -->
      <div
        (appClickOutside)="globalDropdowns.passenger = false"
        class="input-search w-full relative cursor-pointer"
        [ngClass]="{
          'shadow-[inset_0_0_0_1.5px_#369be7]': globalDropdowns.passenger
        }"
      >
        <span class="label-search">{{ "Search.Passengers" | translate }}</span>
        <div
          (click)="globalDropdowns.passenger = !globalDropdowns.passenger"
          class="flex items-center gap-2"
        >
          <img
            src="/icons/passenger.svg"
            alt="passenger-icon"
            class="w-6 h-6"
          />
          <div
            class="flex items-center gap-2 flex-wrap text-secondary dark:text-white font-medium text-[12px] sm:text-sm"
          >
            @for (passenger of passengerSummary; track $index ; let i = $index)
            {
            <span>
              {{ passenger }}
            </span>

            }
          </div>
        </div>

        <!-- passengers: − n + rows (the results-page search's popup) -->
        @if(globalDropdowns.passenger) {
        <div
          class="absolute top-[calc(100%+8px)] left-0 rtl:left-auto rtl:right-0 z-50 flex flex-col gap-2 w-full min-w-[280px] p-3.5 rounded-[14px] font-nunito bg-white dark:bg-[#1e1e48] shadow-[0_12px_32px_rgba(22,26,37,.12),0_0_0_1px_#eaeaea] cursor-auto text-left motion-safe:transition-[opacity,translate] motion-safe:duration-[160ms] motion-safe:ease-out starting:opacity-0 starting:-translate-y-1"
          role="dialog"
          [attr.aria-label]="'Search.Passengers' | translate"
        >
          @for (type of paxTypes; track type.key) {
          <div
            class="flex items-center justify-between min-h-12 ps-4 pe-3 rounded-[10px] bg-[#eff5fd] dark:bg-[#22225e]"
          >
            <button
              type="button"
              class="grid place-items-center w-6 h-6 rounded-md text-[#6b7280] dark:text-[#b4b7c9] transition-[background,color,transform] duration-150 enabled:hover:text-[#369be7] enabled:hover:bg-white enabled:hover:shadow-[inset_0_0_0_1px_#369be7] dark:enabled:hover:bg-[#1e1e48] enabled:active:scale-90 disabled:opacity-35 disabled:cursor-default focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#369be7]"
              [disabled]="!canDecrease(type.key)"
              [attr.aria-label]="
                'Search.One_Less'
                  | translate : { type: (paxLabel(type.key, 1) | translate) }
              "
              (click)="decrease(type.key)"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <span
              class="text-sm leading-5 font-bold text-[#6b7280] dark:text-[#b4b7c9]"
            >
              {{ passengers[type.key] }}
              {{ paxLabel(type.key, passengers[type.key]) | translate }}
            </span>
            <button
              type="button"
              class="grid place-items-center w-6 h-6 rounded-md text-[#6b7280] dark:text-[#b4b7c9] transition-[background,color,transform] duration-150 enabled:hover:text-[#369be7] enabled:hover:bg-white enabled:hover:shadow-[inset_0_0_0_1px_#369be7] dark:enabled:hover:bg-[#1e1e48] enabled:active:scale-90 disabled:opacity-35 disabled:cursor-default focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#369be7]"
              [disabled]="!canIncrease(type.key)"
              [attr.aria-label]="
                'Search.One_More'
                  | translate : { type: (paxLabel(type.key, 1) | translate) }
              "
              (click)="increase(type.key)"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
                  fill="currentColor"
                />
                <path
                  d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
          }
        </div>
        }
      </div>
      <!-- class -->
      <div
        (appClickOutside)="globalDropdowns.class = false"
        class="input-search w-full relative cursor-pointer"
        [ngClass]="{
          'shadow-[inset_0_0_0_1.5px_#369be7]': globalDropdowns.class
        }"
      >
        <span class="label-search">{{
          "Search.Flight_Class" | translate
        }}</span>
        <div
          class="flex items-center gap-2"
          (click)="globalDropdowns.class = !globalDropdowns.class"
        >
          <img src="/icons/class.svg" alt="class-icon" class="w-6 h-6" />
          <span
            class="text-sm w-fit"
            [ngClass]="{
              'text-secondary font-medium dark:text-white ': selectedClass,
              'text-muted font-normal ': !selectedClass
            }"
          >
            {{ selectedClassLabel | translate }}
          </span>
        </div>
        <!-- flight class: radios (the results-page search's popup) -->
        @if(globalDropdowns.class ){
        <div
          class="absolute top-[calc(100%+8px)] left-0 rtl:left-auto rtl:right-0 z-50 flex flex-col gap-2 w-full min-w-[280px] p-3.5 rounded-[14px] font-nunito bg-white dark:bg-[#1e1e48] shadow-[0_12px_32px_rgba(22,26,37,.12),0_0_0_1px_#eaeaea] cursor-auto text-left motion-safe:transition-[opacity,translate] motion-safe:duration-[160ms] motion-safe:ease-out starting:opacity-0 starting:-translate-y-1"
          role="radiogroup"
          [attr.aria-label]="'Search.Flight_Class' | translate"
        >
          @for (typeClass of classes; track typeClass.value) {
          <button
            type="button"
            role="radio"
            class="group flex items-center gap-2.5 min-h-12 py-2.5 px-4 rounded-[10px] text-start bg-[#eff5fd] dark:bg-[#22225e] hover:bg-[#e6f0fb] hover:shadow-[inset_0_0_0_1px_#369be7] dark:hover:bg-[#2c2c6a] focus-visible:outline-none focus-visible:bg-[#e9f2fc] dark:focus-visible:bg-[#2c2c6a]"
            [class.on]="selectedClass === typeClass.value"
            [attr.aria-checked]="selectedClass === typeClass.value"
            (click)="onClassChange(typeClass.value)"
          >
            <span
              class="flex-none w-[18px] h-[18px] rounded-full bg-white dark:bg-[#1e1e48] shadow-[inset_0_0_0_1.25px_#eaeaea] dark:shadow-[inset_0_0_0_1.25px_#2c2c6a] transition-[background,box-shadow] duration-150 group-[.on]:bg-[radial-gradient(circle,#17c552_0_4px,rgba(23,197,82,.1)_4.5px)] group-[.on]:shadow-[inset_0_0_0_1.25px_#17c552] dark:group-[.on]:bg-[radial-gradient(circle,#36e772_0_4px,rgba(54,231,114,.16)_4.5px)] dark:group-[.on]:shadow-[inset_0_0_0_1.25px_#36e772]"
            ></span>
            <b
              class="text-sm leading-5 font-bold text-[#6b7280] dark:text-[#b4b7c9] group-[.on]:text-[#242456] dark:group-[.on]:text-[#f1f1f1]"
            >
              {{ typeClass.label | translate }}
            </b>
          </button>
          }
        </div>
        }
      </div>

      <!-- flight stop -->
      <div
        (appClickOutside)="globalDropdowns.stop = false"
        class="input-search w-full relative cursor-pointer"
        [ngClass]="{
          'shadow-[inset_0_0_0_1.5px_#369be7]': globalDropdowns.stop
        }"
      >
        <span class="label-search">{{
          "Search.Flight_Stops" | translate
        }}</span>
        <div
          class="flex items-center justify-between gap-2"
          (click)="globalDropdowns.stop = !globalDropdowns.stop"
        >
          <span class="text-sm w-fit text-secondary font-medium">
            {{ stopsText }}
          </span>
          <svg
            class="w-5 h-5 transition-transform duration-300 text-[#6B7280]"
            [ngClass]="{ 'rotate-180': globalDropdowns.stop }"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
        <!-- stops: several at once, the last one stays (the results-page search's popup) -->
        @if(globalDropdowns.stop ){
        <div
          class="absolute top-[calc(100%+8px)] left-0 rtl:left-auto rtl:right-0 z-50 flex flex-col gap-2 w-full min-w-[280px] p-3.5 rounded-[14px] font-nunito bg-white dark:bg-[#1e1e48] shadow-[0_12px_32px_rgba(22,26,37,.12),0_0_0_1px_#eaeaea] cursor-auto text-left motion-safe:transition-[opacity,translate] motion-safe:duration-[160ms] motion-safe:ease-out starting:opacity-0 starting:-translate-y-1"
          role="group"
          [attr.aria-label]="'Search.Stops' | translate"
        >
          @for (s of allStops; track s.value) {
          <button
            type="button"
            role="checkbox"
            class="group flex items-center gap-3 w-full min-h-12 px-4 rounded-[10px] text-start text-sm leading-5 font-bold bg-[#eff5fd] text-[#6b7280] dark:bg-[#22225e] dark:text-[#b4b7c9] aria-checked:text-[#242456] dark:aria-checked:text-[#f1f1f1] hover:bg-[#e6f0fb] hover:shadow-[inset_0_0_0_1px_#369be7] dark:hover:bg-[#2c2c6a] focus-visible:outline-none focus-visible:bg-[#e9f2fc] dark:focus-visible:bg-[#2c2c6a]"
            [attr.aria-checked]="isStop(s.value)"
            (click)="toggleStop(s.value)"
          >
            <i
              class="flex-none grid place-items-center w-[18px] h-[18px] rounded-[5px] bg-white dark:bg-[#1e1e48] shadow-[inset_0_0_0_1px_#eaeaea] dark:shadow-[inset_0_0_0_1px_#2c2c6a] transition-[background-color,box-shadow] duration-150 group-aria-checked:bg-[#36e772] dark:group-aria-checked:bg-[#36e772] group-aria-checked:shadow-none dark:group-aria-checked:shadow-none"
            >
              <svg
                class="hidden group-aria-checked:block w-3 h-3"
                viewBox="0 0 10 10"
                aria-hidden="true"
              >
                <path
                  d="M1.4 5.2 3.9 7.6 8.6 2.6"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </i>
            <span>{{ s.label | translate }}</span>
          </button>
          }
        </div>
        }
      </div>

      <button
        type="button"
        (click)="onSearch()"
        class="bg-brand px-6 w-full text-white text-lg font-medium rounded-2xl h-[56px] hover:bg-[#1d8ed3] transition-colors duration-300"
      >
        {{ "Search.Button_Search" | translate }}
      </button>
    </div>
  </form>
</div>

@if (sameAirportPopup) {
<app-same-airport (close)="closePopup()" />
}

<!-- a date: "Sat, 31 Oct 2026", ‹ › one day, the calendar over the field (the results-page search's) -->
<ng-template #dateBoxTpl let-i="i" let-field="field" let-half="half">
  <div
    class="input-search w-full relative"
    [ngClass]="{
      'md:w-1/2': half,
      'is-invalid': isSubmitted && getTripControl(i, field).invalid,
      'shadow-[inset_0_0_0_1.5px_#369be7]': isCal(i, field)
    }"
    (appClickOutside)="isCal(i, field) && closeCal()"
  >
    <button
      type="button"
      class="block w-full pe-14 text-start cursor-pointer"
      [attr.aria-expanded]="isCal(i, field)"
      (click)="toggleCal(i, field)"
    >
      <span class="label-search">{{
        (field === "returnDate" ? "Search.Return_Date" : "Search.Depart_Date")
          | translate
      }}</span>
      <span class="flex items-center gap-2">
        <img src="/icons/date.svg" alt="" class="w-6 h-6" />
        @if (getTripControl(i, field).value) {
        <span class="truncate text-secondary dark:text-white font-medium">{{
          getTripControl(i, field).value | date : "EEE, d MMM y"
        }}</span>
        } @else {
        <span class="truncate text-muted font-normal">{{
          "Search.Select_Date" | translate
        }}</span>
        }
      </span>
    </button>
    <span class="absolute end-4 bottom-3 flex items-center gap-3">
      <button
        type="button"
        class="grid place-items-center w-5 h-5 rounded text-[#6b7280] dark:text-[#b4b7c9] hover:text-[#242456] dark:hover:text-white rtl:rotate-180"
        [attr.aria-label]="'Search.Previous_Day' | translate"
        (click)="shiftDay(i, field, -1)"
      >
        <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M12.5 17.225C12.342 17.225 12.184 17.167 12.059 17.042L6.625 11.608C5.742 10.725 5.742 9.275 6.625 8.392L12.059 2.958C12.3 2.717 12.7 2.717 12.942 2.958C13.184 3.2 13.184 3.6 12.942 3.842L7.509 9.275C7.109 9.675 7.109 10.325 7.509 10.725L12.942 16.158C13.184 16.4 13.184 16.8 12.942 17.042C12.817 17.158 12.659 17.225 12.5 17.225Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <button
        type="button"
        class="grid place-items-center w-5 h-5 rounded text-[#6b7280] dark:text-[#b4b7c9] hover:text-[#242456] dark:hover:text-white rtl:rotate-180"
        [attr.aria-label]="'Search.Next_Day' | translate"
        (click)="shiftDay(i, field, 1)"
      >
        <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M7.425 17.225C7.266 17.225 7.108 17.167 6.983 17.042C6.741 16.8 6.741 16.4 6.983 16.158L12.416 10.725C12.816 10.325 12.816 9.675 12.416 9.275L6.983 3.842C6.741 3.6 6.741 3.2 6.983 2.958C7.225 2.717 7.625 2.717 7.866 2.958L13.3 8.392C13.725 8.817 13.966 9.392 13.966 10C13.966 10.608 13.733 11.183 13.3 11.608L7.866 17.042C7.741 17.158 7.583 17.225 7.425 17.225Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </span>
    @if (isCal(i, field)) {
    <ng-container
      [ngTemplateOutlet]="calPopTpl"
      [ngTemplateOutletContext]="{ field }"
    />
    }
  </div>
</ng-template>

<!-- the calendar: two months, Cancel / Apply -->
<ng-template #calPopTpl let-field="field">
  <div
    class="absolute -top-3.5 z-50 flex flex-col gap-3 w-[620px] max-w-[calc(100vw-32px)] p-4 rounded-[14px] font-nunito text-[#161a25] bg-white dark:bg-[#1e1e48] dark:text-[#f1f1f1] shadow-[0_12px_32px_rgba(22,26,37,.12),0_0_0_1px_#eaeaea] cursor-auto text-left rtl:text-right motion-safe:transition-[opacity,translate] motion-safe:duration-[160ms] motion-safe:ease-out starting:opacity-0 starting:-translate-y-1"
    [ngClass]="
      field === 'returnDate'
        ? '-right-3.5 rtl:right-auto rtl:-left-3.5'
        : '-left-3.5 rtl:left-auto rtl:-right-3.5'
    "
    role="dialog"
    [attr.aria-label]="
      (field === 'returnDate' ? 'Search.Return_Date' : 'Search.Depart_Date')
        | translate
    "
  >
    <!-- the field, on top -->
    <div
      class="flex flex-col justify-center gap-1 min-h-14 py-1.5 px-4 rounded-[10px] bg-[#f1f9ff] dark:bg-[#22225e] shadow-[inset_0_0_0_1px_#eaeaea] dark:shadow-[inset_0_0_0_1px_#2c2c6a]"
    >
      <span
        class="text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]"
        >{{
          (field === "returnDate" ? "Search.Return_Date" : "Search.Depart_Date")
            | translate
        }}</span
      >
      <span class="flex items-center gap-1.5">
        <svg
          class="flex-none w-5 h-5 text-[#86c3f1]"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
            fill="currentColor"
          />
          <path
            d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
            fill="currentColor"
          />
          <path
            d="M20.5 9.83H3.5C3.09 9.83 2.75 9.49 2.75 9.08C2.75 8.67 3.09 8.33 3.5 8.33H20.5C20.91 8.33 21.25 8.67 21.25 9.08C21.25 9.49 20.91 9.83 20.5 9.83Z"
            fill="currentColor"
          />
          <path
            d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
            fill="currentColor"
          />
          <circle cx="8.5" cy="13.5" r="1" fill="currentColor" />
          <circle cx="12" cy="13.5" r="1" fill="currentColor" />
          <circle cx="8.5" cy="17" r="1" fill="currentColor" />
        </svg>
        <b
          class="text-base leading-[22px] font-bold text-[#242456] dark:text-[#f1f1f1]"
          >{{
            cal()?.tmp
              ? (cal()!.tmp | date : "EEE, d MMM y")
              : ("Search.Select_Date" | translate)
          }}</b
        >
      </span>
    </div>

    <div class="relative grid grid-cols-1 sm:grid-cols-2 gap-3">
      <button
        type="button"
        class="absolute top-1 left-2.5 grid place-items-center w-6 h-6 rounded-full text-[#cacaca] hover:text-[#6b7280] disabled:opacity-30 disabled:hover:text-[#cacaca] focus-visible:outline-none focus-visible:bg-[#eef5fd] rtl:left-auto rtl:right-2.5 rtl:rotate-180"
        [disabled]="!canPrevMonth"
        [attr.aria-label]="'Search.Previous_Month' | translate"
        (click)="moveMonth(-1)"
      >
        <svg
          class="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M15.79 18.7C16 18.91 16.12 19.2 16.12 19.5C16.12 19.79 16 20.08 15.79 20.29C15.58 20.5 15.29 20.62 14.99 20.62C14.7 20.62 14.41 20.5 14.2 20.29L6.7 12.79C6.59 12.69 6.51 12.56 6.45 12.43C6.4 12.29 6.37 12.14 6.37 12C6.37 11.85 6.4 11.7 6.45 11.56C6.51 11.43 6.59 11.3 6.7 11.2L14.2 3.7C14.41 3.49 14.7 3.37 14.99 3.37C15.29 3.37 15.58 3.49 15.79 3.7C16 3.91 16.12 4.2 16.12 4.5C16.12 4.79 16 5.08 15.79 5.29L9.09 12L15.79 18.7Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <button
        type="button"
        class="absolute top-1 right-2.5 grid place-items-center w-6 h-6 rounded-full text-[#cacaca] hover:text-[#6b7280] focus-visible:outline-none focus-visible:bg-[#eef5fd] rtl:right-auto rtl:left-2.5 rtl:rotate-180"
        [attr.aria-label]="'Search.Next_Month' | translate"
        (click)="moveMonth(1)"
      >
        <svg
          class="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M17.296 12.796L9.796 20.296C9.585 20.507 9.298 20.626 8.999 20.626C8.7 20.626 8.413 20.507 8.202 20.296C7.991 20.085 7.872 19.798 7.872 19.499C7.872 19.2 7.991 18.914 8.202 18.702L14.906 12L8.204 5.296C8.099 5.191 8.016 5.067 7.96 4.93C7.903 4.794 7.874 4.647 7.874 4.499C7.874 4.351 7.903 4.204 7.96 4.068C8.016 3.931 8.099 3.807 8.204 3.702C8.309 3.598 8.433 3.514 8.57 3.458C8.706 3.401 8.853 3.372 9.001 3.372C9.149 3.372 9.295 3.401 9.432 3.458C9.569 3.514 9.693 3.598 9.798 3.702L17.298 11.202C17.403 11.307 17.486 11.431 17.542 11.568C17.599 11.705 17.628 11.851 17.628 11.999C17.628 12.148 17.598 12.294 17.541 12.431C17.484 12.567 17.401 12.692 17.296 12.796Z"
            fill="currentColor"
          />
        </svg>
      </button>
      @for (m of months(); track m.ym) {
      <div>
        <b
          class="block h-8 mb-2 text-center text-sm leading-8 font-bold text-[#242456] dark:text-[#f1f1f1]"
          >{{ m.first | date : "MMMM y" }}</b
        >
        <div class="grid grid-cols-[repeat(7,38px)] justify-center gap-y-0.5">
          @for (d of weekDays; track $index) {
          <span
            class="grid place-items-center h-8 text-sm font-bold text-[#6b7280] dark:text-[#b4b7c9]"
            >{{ d }}</span
          >
          }
        </div>
        <div class="grid grid-cols-[repeat(7,38px)] justify-center gap-y-0.5">
          @for (c of m.cells; track $index) { @if (c.out) {
          <span
            class="grid place-items-center w-[38px] h-[38px] text-sm text-[#cacaca] dark:text-[#4b4b7a]"
            >{{ c.day }}</span
          >
          } @else {
          <button
            type="button"
            class="grid place-items-center w-[38px] h-[38px] text-sm focus-visible:outline-none"
            [ngClass]="
              c.on
                ? 'rounded-full bg-[#37377d] text-white font-bold'
                : c.dis
                ? 'rounded-full text-[#cacaca] dark:text-[#4b4b7a] cursor-default'
                : c.rng
                ? 'rounded-md bg-[#f1f9ff] dark:bg-[#22225e] text-[#6b7280] dark:text-[#b4b7c9] hover:bg-[#eff5fd] dark:hover:bg-[#2c2c6a] focus-visible:bg-[#eef5fd]'
                : c.tod
                ? 'rounded-full text-[#afd7f5] font-bold hover:bg-[#eff5fd] dark:hover:bg-[#2c2c6a] focus-visible:bg-[#eef5fd]'
                : 'rounded-full text-[#6b7280] dark:text-[#b4b7c9] hover:bg-[#eff5fd] dark:hover:bg-[#2c2c6a] focus-visible:bg-[#eef5fd]'
            "
            [disabled]="c.dis"
            [attr.aria-label]="c.iso | date : 'EEE, d MMM y'"
            [attr.aria-pressed]="c.on"
            (click)="pickDay(c.iso)"
          >
            {{ c.day }}
          </button>
          } }
        </div>
      </div>
      }
    </div>

    <div
      class="flex justify-end gap-2 -mx-3.5 px-3.5 pt-3 border-t border-[#eaeaea] dark:border-[#2c2c6a]"
    >
      <button
        type="button"
        class="inline-flex items-center justify-center min-w-[120px] h-10 px-4 rounded-[10px] text-sm leading-5 font-semibold bg-white text-[#6b7280] shadow-[inset_0_0_0_1px_#eaeaea] hover:shadow-[inset_0_0_0_1px_#369be7] dark:bg-[#1e1e48] dark:text-[#b4b7c9] dark:shadow-[inset_0_0_0_1px_#2c2c6a]"
        (click)="closeCal()"
      >
        {{ "Shared.Cancel" | translate }}
      </button>
      <button
        type="button"
        class="inline-flex items-center justify-center min-w-[120px] h-10 px-4 rounded-[10px] text-sm leading-5 font-semibold bg-[#369be7] text-white hover:bg-[#1d8ed3] disabled:bg-[#eaeaea] disabled:text-[#6b7280] disabled:cursor-default"
        [disabled]="!cal()?.tmp"
        (click)="applyCal()"
      >
        {{ "Search.Apply" | translate }}
      </button>
    </div>
  </div>
</ng-template>
